import styled from 'styled-components';
import { ListDescriptionSection } from './ListDescriptionSection';
import { ListDetails } from './ListDetails';

export const testIds = {
  listSubHeaderContainer: 'list-sub-header-container',
};

export const SubHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListSubHeader = () => {
  return (
    <SubHeaderContainer data-test={testIds.listSubHeaderContainer}>
      <ListDescriptionSection />
      <ListDetails />
    </SubHeaderContainer>
  );
};
